import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@/helpers/axios";
import type { ApiResponse } from "@/helpers/axios";
import type { Group } from "../_types/groups.types";
import type { GroupKindFilter, GroupToolbarTab } from "../_constants/groups.const";

export const useGroupsQuery = (opts: {
  kind: GroupKindFilter;
  tab: GroupToolbarTab;
}) =>
  useQuery({
    queryKey: ["groups", opts.kind, opts.tab],
    queryFn: async (): Promise<Group[]> => {
      const archived =
        opts.tab === "archived" ? "1" : opts.tab === "active" ? "0" : "all";
      const response = await axiosInstance.get<
        ApiResponse<{ items: Group[] }>
      >("/v2/groups", {
        params: {
          kind: opts.kind,
          archived,
        },
      });
      return response.data.data?.items ?? [];
    },
  });
